<template>
  <app-entity :entity="entityLocal" @close-card="closeCard" :loading="false" />
</template>

<script>
import useDataType from './useDataType';
import { onMounted, watch } from '@vue/composition-api';

export default {
  name: 'DataTypeItem',
  props: ['id'],
  setup(props, context) {
    const entityComposition = useDataType(props, context);

    const closeCard = () => {
      entityComposition.entity.value = null;
      context.root.$router.push({
        name: 'datatypes',
        query: context.root.$route.query
      });
    };

    watch(
      () => props.id,
      () => {
        entityComposition.loadData(props.id);
      }
    );

    onMounted(() => {
      entityComposition.loadData(props.id);
    });

    return {
      ...entityComposition,
      closeCard
    };
  }
};
</script>
